import React, { useEffect } from "react";
import "./Services.css";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllTodaysPath, OurOfferings } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const Services = () => {
  const data = [
    {
      label: "Your Spiritual Stay",
      img: "/assets/images/home/services/img1.png",
      link: '/guest-house',
    },
    {
      label: "Wellness Store",
      img: "/assets/images/home/services/img2.png",
      link: '/explore-latest-products',
    },
    {
      label: "Event Registrations",
      img: "/assets/images/home/services/img3.png",
      link: '/event-registration',
    },
    {
      label: "Meditation Blogs",
      img: "/assets/images/home/services/img4.png",
      link: '/all-meditations',
    },
  ];



  const dispatch = useDispatch();
  const offerings = useSelector((state) => state.common.all_offerings);

  useEffect(() => {
    dispatch(OurOfferings());
  }, [dispatch])

  return (
    <section className="Services">
      <div className="container">
        <Common_Title_1 titleText="SERVICES" subText="Our Offerings for You" />

        <div className="content_div">
          <div className="row">
            {offerings?.map((item, index) => {
              return (
                <div className="col-lg-3 col-sm-6">
                  <Link to={item?.Our_Offering?.link}>
                    <div className="service_card">
                      <div className="img_holder">
                        <img
                          src={IDS.IMG_URL + item?.Our_Offering?.image}
                          className="inner_img"
                        />
                      </div>
                      <div
                        className={`orange_bg_div ${index % 2 === 0 ? "even" : "odd"
                          }`}
                      >
                        <p className="label_text">{item?.name}</p>
                      </div>

                      <div className="overlay_colour"></div>

                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
